import logoAnim from "../../media/logo_anim.gif";
import useWindowDimensions from "../util/useWindowDimensions";
import { useScrollbarWidth } from "../util/useScrollbarWidth";

const Header = () => {
  // const [activeIndex, setActiveIndex] = useState(0);
  // const springApi = useSpringRef();
  const { width } = useWindowDimensions();
  const scrollBarWidth = useScrollbarWidth();
  return (
    <header>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={logoAnim}
          alt="logo"
          style={{
            maxWidth: 900,
            width: width - scrollBarWidth,
            height: "auto",
          }}
        />
      </div>
    </header>
  );
};

export default Header;
